"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SectionHeader = exports.MyInformationWrapper = exports.MyInformationContent = exports.MyInformationChangeMessage = void 0;
var _mui = require("@ori-ui/mui");
var _styles = require("../CheckoutStep/styles");
const MyInformationWrapper = exports.MyInformationWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        ...(0, _styles.sectionStyles)(theme)
    };
});
const SectionHeader = exports.SectionHeader = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        ...(0, _styles.sectionHeaderStyles)(),
        marginBottom: theme.spacing(4)
    };
});
const MyInformationContent = exports.MyInformationContent = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1)
    };
});
const MyInformationChangeMessage = exports.MyInformationChangeMessage = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        marginTop: theme.spacing(2)
    };
});
